import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceProjectRoleActorRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-project-role-actor',
	path: '/jira/settings/system/performance/metrics/projectroleactor',
};
